import React, { useState, useEffect } from 'react';
import { Radio, Modal, Button, message, Tooltip } from 'antd';
import { useAuth } from '../commons/contexts/auth-context';

export default function GroupSelectorModal(props) {
  const { groups, selectGroup } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [group, setGroup] = useState({});
  const [orderedGroups, setOrderedGroups] = useState([]);

  //effect to reorder the list of groups
  useEffect(() => {
    groups.availables.sort((a, b) => a.t - b.t || a.d.localeCompare(b.d));

    let disabled = groups.availables.filter(el => el.enabled === 0);
    let enabled = groups.availables.filter(el => el.enabled !== 0);

    let ordered = [...enabled, ...disabled];

    setOrderedGroups(ordered);
  }, [groups]);

  function handleChange(e) {
    const id = e.target.value.substring(0, e.target.value.indexOf('/'));
    const role = e.target.value.substring(
      e.target.value.indexOf('/') + 1,
      e.target.value.length
    );

    const group =
      groups.availables.find(group => group.g === id && group.r === role) || {};
    setGroup(group);
  }

  async function handleSubmit(e) {
    if (!group.g) return;

    try {
      setSubmitting(true);

      await selectGroup(group);

      setGroup({});
    } catch (e) {
      setSubmitting(false);
      message.error(e.message);
    }
  }

  return (
    <Modal
      id="groups-modal"
      visible={true}
      title="Login to a Group"
      okText="Log In"
      className="groups-modal"
      onCancel={props.cancelLogin}
      maskClosable={false}
      footer={[
        <Button onClick={props.cancelLogin}>Cancel</Button>,
        <Button
          type="primary"
          disabled={!group.g}
          onClick={handleSubmit}
          loading={submitting}
          key="log-in"
        >
          Login to group
        </Button>,
      ]}
    >
      <p className="alt-left">Please select group</p>
      <Radio.Group
        onChange={handleChange}
        value={`${group.g}/${group.r}`}
        className="w-100"
      >
        {orderedGroups.map((g, i) => (
          <GroupItem group={g} selectedGroup={group} key={i} />
        ))}
      </Radio.Group>
    </Modal>
  );
}

const GroupItem = ({ group, selectedGroup }) => {
  let isActive =
    `${group.g}/${group.r}` === `${selectedGroup.g}/${selectedGroup.r}`;
  return (
    <Radio
      size="large"
      className="flex items-center mb-2 px-1 py-1"
      disabled={!Boolean(group.enabled)}
      style={{
        border: isActive ? '1px solid #40a9ff' : '1px solid #e6e6e6',
        borderRadius: '4px',
      }}
      key={`${group.g}/${group.r}`}
      value={`${group.g}/${group.r}`}
    >
      <Tooltip
        title={!Boolean(group.enabled) ? 'This group is disabled' : ''}
        placement="right"
      >
        <div>
          <strong>
            <span style={{ display: 'block', fontSize: '' }}>
              {group.d?.split(':')[1]}
            </span>
          </strong>
          <span style={{ display: 'block' }}>{group.d?.split(':')[0]}</span>
        </div>
      </Tooltip>
    </Radio>
  );
};
